export function buildSelector(globalState) {
  const { name, fields } = this;
  return fields.reduce((acc, field) => acc[field], globalState[name]);
}
